import * as designsEntitiesTypes from "state/entities/designs/designsTypes";
import {
  handleDesignRequest,
  handleDesignRequestSuccess
} from "state/api/designs/apiDesignsReducersCommonCases";

export const initState = {
  pages: {},
  detailedIds: {},
  totalCount: null,
  pageSize: 50
};

const queryApiReducers = (state = initState, action) => {
  switch (action.type) {
    case designsEntitiesTypes.DESIGNS_DRAFTS_REQUEST: {
      return handleDesignRequest({ state, action });
    }

    case designsEntitiesTypes.DESIGNS_DRAFTS_REQUEST_SUCCESS: {
      return handleDesignRequestSuccess({ state, action });
    }

    default:
      return state;
  }
};

export default queryApiReducers;
